/**
 * Example API
 * Example description of API.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Configuration } from "../requests/configuration";
import * as Instance from "../Instance";
import * as ModelHelperSrc from "../model/HelperSrc";
import { API_PATH } from "../store/ui";
import { CellChange } from "../interface";

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|"
};

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | null = null;

    constructor(
        configuration: Configuration,
        protected basePath: string = API_PATH
    ) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name = "RequiredError";
    constructor(
        public field: string,
        msg?: string
    ) {
        super(msg);
    }
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    public authLoginCreate(username: string, psw: string, callback: ModelHelperSrc.IapiCallback): void {
        const authHeader = `Basic ${btoa(`${username}:${psw}`)}`;

        Instance.api
            .post<ModelHelperSrc.Iresponse>(
                "/auth/login/",
                {
                    headers: {
                        Authorization: authHeader
                    }
                },
                {}
            )
            .then((response) => {
                return callback(response.data);
            })
            .catch((error: Error) => {
                return callback(error);
            });
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authLoginAdCreate(token: string, callback: ModelHelperSrc.IapiCallback): void {
        Instance.api
            .post<ModelHelperSrc.Iresponse>(
                "/auth/loginAd/",
                {
                    headers: {
                        Authorization: token
                    }
                },
                {}
            )
            .then((response) => {
                return callback(response.data);
            })
            .catch((error: Error) => {
                return callback(error);
            });
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authLogoutCreate(callback: ModelHelperSrc.IapiCallback): void {
        Instance.api
            .post<ModelHelperSrc.Iresponse>(
                "/auth/logout/",
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                {}
            )
            .then((response) => {
                return callback(response.data);
            })
            .catch((error: Error) => {
                return callback(error);
            });
    }

    public clearApplication(callback: ModelHelperSrc.IapiCallback): void {
        Instance.api
            .get<ModelHelperSrc.Iresponse>("/auth/clear_application/", {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                return callback(response.data);
            })
            .catch((error: Error) => {
                return callback(error);
            });
    }
}

/**
 * ClientApi - object-oriented interface
 * @export
 * @class ClientApi
 * @extends {BaseAPI}
 */
export class ClientApi extends BaseAPI {
    /**
     * GET endpoint to view logs only
     * @param {string} db
     * @param {number} [page] A page number within the paginated result set.
     * @param {string} [filter] Query Filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientAuditlogList(db: string, page: number, filter: string): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            db,
            page: String(page),
            filter
        };

        const urlParameter = new URLSearchParams(data);

        return Instance.api
            .get<ModelHelperSrc.Iresponse>(`/client/${encodeURIComponent(db)}/auditlog/?${urlParameter.toString()}`, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                return response.data;
            });
    }

    /**
     * GET endpoint to view logs only
     * @param {string} db
     * @param {Log} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientAuditlogLogin(db: string, message: string): Promise<ModelHelperSrc.Iresponse> {
        return Instance.api
            .post<ModelHelperSrc.Iresponse>(
                `/client/${encodeURIComponent(db)}/auditlog/login/`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                { message }
            )
            .then((response) => {
                return response.data;
            });
    }

    /**
     * Manage clients such as NBB and XBB
     * @param {Database} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientCreate(name: String): Promise<ModelHelperSrc.Iresponse> {
        return Instance.api
            .post<ModelHelperSrc.Iresponse>(
                "/client/",
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                { name }
            )
            .then((response) => {
                return response.data;
            });
    }

    /**
     * Manage clients such as NBB and XBB
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientList(): Promise<ModelHelperSrc.Iresponse> {
        return Instance.api
            .get<ModelHelperSrc.Iresponse>(`/client/`, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                return response.data;
            });
    }

    /**
     * Endpoints for workbook info
     * @param {string} db
     * @param {Workbook} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientWorkbookCreate(db: string, name: string, year: number, isPrimary: boolean): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            name,
            year: year,
            is_primary: isPrimary
        };

        return Instance.api
            .post<ModelHelperSrc.Iresponse>(
                `/client/${encodeURIComponent(db)}/workbook/`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                data
            )
            .then((response) => {
                return response.data;
            });
    }

    /**
     * Endpoints for workbook info
     * @param {string} db
     * @param {number} id A unique integer value identifying this workbook.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientWorkbookDelete(db: string, id: number): Promise<ModelHelperSrc.Iresponse> {
        return Instance.api
            .delete<ModelHelperSrc.Iresponse>(
                `/client/${encodeURIComponent(db)}/workbook/${encodeURIComponent(String(id))}/`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                { id }
            )
            .then((response) => {
                return response.data;
            });
    }

    /**
     * Endpoints for workbook info
     * @param {string} db
     * @param {string} [isPrimary]
     * @param {number} [year]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientWorkbookList(db: string, isPrimary: boolean, year?: number): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            year: year !== undefined ? String(year) : "",
            is_primary: String(isPrimary)
        };

        const urlParameter = new URLSearchParams(data);

        return Instance.api
            .get<ModelHelperSrc.Iresponse>(`/client/${encodeURIComponent(db)}/workbook/?${urlParameter.toString()}`, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                return response.data;
            });
    }

    /**
     * Endpoints for workbook info
     * @param {string} db
     * @param {number} id A unique integer value identifying this workbook.
     * @param {Workbook} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientWorkbookPartialUpdate(
        db: string,
        id: number,
        clientWorkbookData: ModelHelperSrc.IclientWorkbookData
    ): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            name: clientWorkbookData.name,
            year: clientWorkbookData.year,
            is_primary: clientWorkbookData.is_primary,
            is_locked: clientWorkbookData.is_locked
        };

        return Instance.api
            .post<ModelHelperSrc.Iresponse>(
                `/client/${encodeURIComponent(db)}/workbook/${encodeURIComponent(String(id))}`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                data
            )
            .then((response) => {
                return response.data;
            });
    }

    /**
     * Endpoints for workbook info
     * @param {string} db
     * @param {number} id A unique integer value identifying this workbook.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientWorkbookRead(db: string, id: number): Promise<ModelHelperSrc.Iresponse> {
        return Instance.api
            .get<ModelHelperSrc.Iresponse>(`/client/${encodeURIComponent(db)}/workbook/${encodeURIComponent(String(id))}/`, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                return response.data;
            });
    }

    /**
     * Modify individual cells of data
     * @param {string} db
     * @param {string} id
     * @param {Patch} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientWorkbookTableCreate(db: string, id: string, table: string, cellChange: CellChange[]): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            table,
            data: cellChange
        };

        return Instance.api
            .post<ModelHelperSrc.Iresponse>(
                `/client/${encodeURIComponent(db)}/workbook/${encodeURIComponent(id)}/table/`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                data
            )
            .then((response) => {
                return response.data;
            });
    }

    /**
     * Get the data for a table which should be displayed in our spreadsheet
     * @param {string} db
     * @param {string} id
     * @param {string} [tables] Wanted tables as comma separated list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientWorkbookTableList(db: string, id: string, table: string): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            tables: table
        };
        const urlParameter = new URLSearchParams(data);

        return Instance.api
            .get<ModelHelperSrc.Iresponse>(`/client/${encodeURIComponent(db)}/workbook/${encodeURIComponent(id)}/table/?${urlParameter.toString()}`, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                return response.data;
            });
    }

    /**
     * Endpoint to get/update spreadsheet data
     * @param {string} db
     * @param {string} id
     * @param {boolean} [force] Force lock
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientWorkbookTableLock(db: string, id: string, force: boolean): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            force: String(force)
        };

        const urlParameter = new URLSearchParams(data);

        return Instance.api
            .get<ModelHelperSrc.Iresponse>(
                `/client/${encodeURIComponent(db)}/workbook/${encodeURIComponent(id)}/table/lock/?${urlParameter.toString()}`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            )
            .then((response) => {
                return response.data;
            });
    }

    /**
     * This lists files uploaded/needed. It doesn't exactly correspond to any table.
     * @param {string} db
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientWorkbookUploadList(db: string, id: string): Promise<ModelHelperSrc.Iresponse> {
        return Instance.api
            .get<ModelHelperSrc.Iresponse>(`/client/${encodeURIComponent(db)}/workbook/${encodeURIComponent(id)}/upload/`, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                return response.data;
            });
    }
}

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {ChangePasswordRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersChangepassword(id: number, newPassword: string): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            new_psw: newPassword
        };

        return Instance.api
            .put<ModelHelperSrc.Iresponse>(
                `/users/${encodeURIComponent(String(id))}/changepassword/`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                data
            )
            .then((response) => {
                return response.data;
            });
    }

    /**
     *
     * @param {User} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersCreate(
        email: string,
        isSuperuser: boolean,
        isStaff: boolean,
        isSupport: boolean,
        groups: string[]
    ): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            username: email,
            email,
            groups,
            is_superuser: isSuperuser,
            is_staff: isStaff,
            is_support: isSupport
        };

        const dataParam = JSON.stringify(data || {});
        const dataEncoded = window.btoa(encodeURIComponent(dataParam));

        return Instance.api
            .post<ModelHelperSrc.Iresponse>(
                `/users/`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                JSON.stringify(dataEncoded)
            )
            .then((response) => {
                return response.data;
            });
    }

    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersDelete(id: number | undefined): Promise<ModelHelperSrc.Iresponse> {
        return Instance.api
            .delete<ModelHelperSrc.Iresponse>(
                `/users/${encodeURIComponent(String(id))}/`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                {}
            )
            .then((response) => {
                return response.data;
            });
    }

    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {User} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersPartialUpdate(
        id: number,
        isSuperuser: boolean,
        isStaff: boolean,
        isSupport: boolean,
        groups: string[]
    ): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            is_superuser: isSuperuser,
            is_staff: isStaff,
            is_support: isSupport,
            groups
        };

        return Instance.api
            .patch<ModelHelperSrc.Iresponse>(
                `/users/${encodeURIComponent(String(id))}/`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                data
            )
            .then((response) => {
                return response.data;
            });
    }

    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersRead(id: number): Promise<ModelHelperSrc.Iresponse> {
        return Instance.api
            .get<ModelHelperSrc.Iresponse>(`/users/${encodeURIComponent(String(id))}/`, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                return response.data;
            });
    }

    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getMe(): Promise<ModelHelperSrc.Iresponse> {
        return Instance.api
            .get<ModelHelperSrc.Iresponse>(`/me/${encodeURIComponent("0")}/getMe/`, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                return response.data;
            });
    }

    public optApi(userId: number | undefined): Promise<ModelHelperSrc.Iresponse> {
        const dataParam = JSON.stringify({ userId });

        return Instance.api
            .put<ModelHelperSrc.Iresponse>(
                `/users/${encodeURIComponent(String(userId))}/optApi/`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                dataParam
            )
            .then((response) => {
                return response.data;
            });
    }
}

/**
 * DownloadAPI - object-oriented interface
 * @export
 * @class DownloadAPI
 * @extends {BaseAPI}
 */
export class WorkbookApi extends BaseAPI {
    /**
     *
     * @param {string} db A unique integer value identifying the db.
     * @param {string} workbook A unique integer value identifying the workbook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkbookApi
     */
    public getDownloadList(db: string, workbook: string, onlyNew: boolean, tables: string | null): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            only_new: onlyNew,
            tables
        };

        return Instance.api
            .post<ModelHelperSrc.Iresponse>(
                `/client/${encodeURIComponent(db)}/workbook/${encodeURIComponent(String(workbook))}/download/`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                data
            )
            .then((response) => {
                return response.data;
            });
    }

    /**
     *
     * @param {string} db A unique integer value identifying the db.
     * @param {string} workbook A unique integer value identifying the workbook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkbookApi
     */
    public getDownloadStatus(db: string, workbook: string, status: string): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            status
        };

        const urlParameter = new URLSearchParams(data);

        return Instance.api
            .get<ModelHelperSrc.Iresponse>(
                `/client/${encodeURIComponent(String(db))}/workbook/${encodeURIComponent(String(workbook))}/download_status/?${urlParameter.toString()}`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            )
            .then((response) => {
                return response.data;
            });
    }

    /**
     *
     * @param {string} db A unique integer value identifying the db.
     * @param {string} workbook A unique integer value identifying the workbook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkbookApi
     */
    public downloadPreparation(db: string, workbook: string, downloadTime: string): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            download_time: downloadTime
        };

        const urlParameter = new URLSearchParams(data);

        return Instance.api
            .post<ModelHelperSrc.Iresponse>(
                `/client/${encodeURIComponent(String(db))}/workbook/${encodeURIComponent(workbook)}/download_zip_preparation/?${urlParameter.toString()}`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                data
            )
            .then((response) => {
                return response.data;
            });
    }

    public checkZipStatus(db: string, workbook: string, downloadTime: string): Promise<ModelHelperSrc.Iresponse> {
        const data = {
            download_time: downloadTime
        };

        const urlParameter = new URLSearchParams(data);

        return Instance.api
            .get<ModelHelperSrc.Iresponse>(
                `/client/${encodeURIComponent(String(db))}/workbook/${encodeURIComponent(String(workbook))}/check_zip_status/?${urlParameter.toString()}`,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            )
            .then((response) => {
                return response.data;
            });
    }
}
